import { updateCookies } from "../../helpers/updateCookies";
import { api } from "../../services/api";
import { Handler } from "../types/store-types";

import {
    IAuthState,
    AuthActionTypes,
    SetLoadingActionType,
    ClearErrorsActionType,
    InitUserRequestActionType,
    SetUserTokenActionType,
    InitUserSuccessActionType,
    InitUserFailureActionType,
    MigrateGuestToUserRequestActionType,
    MigrateGuestToUserSuccessActionType,
    MigrateGuestToUserFailureActionType,
    IUserTypes,
    GetCurrentUserRequestActionType,
    GetCurrentUserSuccessActionType,
    GetCurrentUserFailureActionType,
    UserRoles,
    InitUserActivationRequestActionType,
    InitUserActivationSuccessActionType,
    InitUserActivationFailureActionType,
} from "./types";

/* -- Init User Request Handler -- */

const initUserActivationRequest: Handler<IAuthState, InitUserActivationRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const initUserActivationSuccess: Handler<IAuthState, InitUserActivationSuccessActionType> = (
    state,
    { payload: { data } },
) => {
    return {
        ...state,
        user: {
            ...data,
            name: data.first_name + " " + data.last_name,
            role: IUserTypes.USER,
        },
    };
};

const initUserActivationFailure: Handler<IAuthState, InitUserActivationFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, errors: payload };
};

const initUserRequest: Handler<IAuthState, InitUserRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const initUserSuccess: Handler<IAuthState, InitUserSuccessActionType> = (
    state,
    { payload: { token, refresh_token, userType } },
) => {
    return {
        ...state,
        isLoading: false,
        userType,
        token,
        refresh_token,
        errors: null,
    };
};

const initUserFailure: Handler<IAuthState, InitUserFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, errors: payload };
};

const getCurrentUserRequest: Handler<IAuthState, GetCurrentUserRequestActionType> = state => {
    return { ...state };
};
const getCurrentUserSuccess: Handler<IAuthState, GetCurrentUserSuccessActionType> = (state, { payload }) => {
    const { first_name, last_name, role, ...rest } = payload;
    const userType = role === UserRoles.GUEST ? IUserTypes.GUEST : IUserTypes.USER;

    return {
        ...state,
        userType,
        user: {
            ...rest,
            role: userType,
            name: first_name + " " + last_name, // I know this is not good , update to more effective code  :)
        },
    };
};
const getCurrentUserFailure: Handler<IAuthState, GetCurrentUserFailureActionType> = state => {
    return { ...state };
};

const migrateUserRequest: Handler<IAuthState, MigrateGuestToUserRequestActionType> = (state, { payload }) => {
    return { ...state };
};
const migrateUserSuccess: Handler<IAuthState, MigrateGuestToUserSuccessActionType> = (
    state,
    { payload: { userId: token, userRefreshToken: refresh_token } },
) => {
    localStorage.clear();
    localStorage.setItem("token", token);
    localStorage.setItem("refresh_token", refresh_token);
    api.defaults.headers.common["x-access-token"] = token;
    return { ...state, token, refresh_token, userType: IUserTypes.USER };
};
const migrateUserFailure: Handler<IAuthState, MigrateGuestToUserFailureActionType> = (state, { payload }) => {
    return { ...state };
};

const setUserToken: Handler<IAuthState, SetUserTokenActionType> = (state, { payload: { token, refresh_token } }) => {
    localStorage.clear();
    localStorage.setItem("token", token);
    localStorage.setItem("refresh_token", token);
    api.defaults.headers.common["x-access-token"] = token;
    updateCookies(token, refresh_token);
    return { ...state, token, refresh_token };
};

const setLoading: Handler<IAuthState, SetLoadingActionType> = (state, { payload: { isLoading } }) => {
    return { ...state, isLoading };
};

const clearErrors: Handler<IAuthState, ClearErrorsActionType> = state => {
    return { ...state, errors: null };
};

export const authHandlers = {
    [AuthActionTypes.INIT_USER_ACTIVATION]: initUserActivationRequest,
    [AuthActionTypes.INIT_USER_ACTIVATION_SUCCESS]: initUserActivationSuccess,
    [AuthActionTypes.INIT_USER_ACTIVATION_FAILURE]: initUserActivationFailure,
    [AuthActionTypes.INIT_USER_REQUEST]: initUserRequest,
    [AuthActionTypes.INIT_USER_SUCCESS]: initUserSuccess,
    [AuthActionTypes.INIT_USER_FAILURE]: initUserFailure,

    [AuthActionTypes.GET_CURRENT_USER_REQUEST]: getCurrentUserRequest,
    [AuthActionTypes.GET_CURRENT_USER_SUCCESS]: getCurrentUserSuccess,
    [AuthActionTypes.GET_CURRENT_USER_FAILURE]: getCurrentUserFailure,

    [AuthActionTypes.MIGRATE_GUEST_TO_USER_REQUEST]: migrateUserRequest,
    [AuthActionTypes.MIGRATE_GUEST_TO_USER_SUCCESS]: migrateUserSuccess,
    [AuthActionTypes.MIGRATE_GUEST_TO_USER_FAILURE]: migrateUserFailure,

    [AuthActionTypes.SET_USER_TOKEN]: setUserToken,
    [AuthActionTypes.SET_LOADING]: setLoading,
    [AuthActionTypes.CLEAR_ERRORS]: clearErrors,
};
